import { render, staticRenderFns } from "./UserApiSwitch.vue?vue&type=template&id=2d320564&"
import script from "./UserApiSwitch.vue?vue&type=script&lang=js&"
export * from "./UserApiSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports